import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataService } from '../services/data.service';

@Injectable()
export class AuthGuard implements CanActivate {
	 constructor(
		private router: Router,
		private data: DataService
	) {}

	 canActivate() {
		let jwt = localStorage.getItem('jwt');

		return this.data.user.profile.view()
		.then(() => {
			this.data.shared.initiate();
			return true;
		})
		.catch(err => {
			this.router.navigate(['/login']);
			return false;
		});
	}
}


// WEBPACK FOOTER //
// ./src/guards/auth.guard.ts